const STORAGE_KEY = 'livezone.competitorColors';

type CompetitorColorMap = Record<string, string>;

const readColors = (): CompetitorColorMap => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as CompetitorColorMap;
  } catch {
    return {};
  }
};

export const getStoredCompetitorColor = (deviceName: string): string | undefined => {
  if (!deviceName) return undefined;
  const color = readColors()[deviceName];
  return typeof color === 'string' && color ? color : undefined;
};

export const setStoredCompetitorColor = (deviceName: string, color: string): void => {
  if (!deviceName || !color) return;
  const colors = readColors();
  colors[deviceName] = color;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(colors));
};
